import { render, staticRenderFns } from "./integral-task-detail.vue?vue&type=template&id=0a2e86de&"
import script from "./integral-task-detail.vue?vue&type=script&lang=js&"
export * from "./integral-task-detail.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports